import { animate, scroll } from 'motion'

const progressTarget =  document.querySelector('[data-progress-target]')

// Progress bar for full page scroll
// scroll(animate('[data-progress]',
//     { width: ['0%', '100%'] }
// ))

if (progressTarget) {
    // Progress for specific element (one per page)
    scroll(animate('[data-progress]', { width: ['0', '100%'] }), {
        target: progressTarget,
    })
}
